import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getUserLocationOptions = get('guest.userLocationOptions');

export const getAll = createSelector(getUserLocationOptions, get('all'));

export const getMeta = createSelector(getUserLocationOptions, get('meta'));

export const getFetching = createSelector(
  getUserLocationOptions,
  get('fetching')
);

export const getFetched = createSelector(
  getUserLocationOptions,
  get('fetched')
);
